import { render, staticRenderFns } from "./OrderComponentRun.vue?vue&type=template&id=585e2c72&"
import script from "./OrderComponentRun.vue?vue&type=script&lang=js&"
export * from "./OrderComponentRun.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentRun.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports